import { TranslateService } from '@ngx-translate/core';
import { AbstractControl } from '@angular/forms';
import { saveAs } from 'file-saver';
import { DialogService } from 'primeng/dynamicdialog';
import { FilterProductComponent } from '../pages/catalog/product/filter/filter-product/filter-product.component';
import { FiltersUtil } from '../pages/catalog/product-list/utils/filters-util';
import { MessageService } from 'primeng/api';
export class Util {
  static downloadXls(data, filename) {
    const blob = new Blob([data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, filename);
  }

  static getSeverity(status) {
    switch (status?.trim()) {
      case 'Accepté':
      case 'VALID':
      case 'ACTIVE':
      case 'SUCCESS':
      case 'PUBLISHABLE':
      case 'SYNCHRONIZED':
      case 'INTEGRATION_COMPLETED':
        return 'success';
      case 'NOT_PUBLISHABLE':
      case 'NOT_SYnCHRONIZED':
      case 'INVALID':
      case 'NOT_ACTIVE':
      case 'ANALYSIS_ERROR':
      case 'ERROR':
      case 'Refusé':
      case 'REJECTED':
      case 'INTEGRATION_ERROR':
      case 'CHANGES_REQUESTED':
      case 'INACTIVE':
      case 'INTEGRATION_COMPLETED_WITH_ERRORS':
        return 'danger';
      case 'En attente de vérification':
      case 'AWAITING_MEDIA':
        return 'warn';
      case 'Nouveau':
      case 'IN_PROGRESS':
      case 'INTEGRATION_IN_PROGRESS':
      case 'PENDING':
      case 'NEW':
      case 'ANALYSIS_IN_PROGRESS':
        return 'info';
      case 'Non applicable':
        return 'secondary';
      default:
        return 'secondary';
    }
  }

  static getSeverityForPublicationStatus (status: string, errors : boolean) {
     if(status === 'SYNCHRONIZED') {
      if(errors) {
        return 'warn';
      }else {
        return 'success';
      }

    } else if(status === 'NOT_SYNCHRONIZED') {
      if(errors) {
        return 'danger';
      }else {
        return 'secondary';
      }
    } else {
      return 'secondary';
    }
  }

  static toUTC(value) {
    if (!value) {
      return '';
    }
    const date = new Date(value);

    const utcDate = new Date(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate(),
      date.getUTCHours(),
      date.getUTCMinutes(),
      date.getUTCSeconds(),
    );

    return utcDate;
  }

  static getMessageSeverity(message) {
    if (message?.trim() === 'CHANGES_REQUESTED' || message?.trim() === 'Error') {
      return 'error';
    } else if(message?.trim() === 'Warning') {
      return 'warn'
    } else {
      return 'info';
    }

  }

  static containsAny(mainStr: string, valuesStr: string): boolean {
    const values = valuesStr.split(' ');
    return values.some((value) => mainStr.includes(value));
  }

  static getFilenameFromHeaders(headers: any): string | null {
    const contentDisposition = headers.get('content-disposition');
    if (contentDisposition) {
      const match = contentDisposition.match(
        /filename\s*=\s*["']?([^"';]+)["']?/,
      );
      return match ? match[1] : null;
    }
    return null;
  }

  static replaceAll(string, search, replace): string {
    return string.split(search).join(replace);
  }

  static isNumericWithDelimiters(value: string): boolean {
    // Nettoyer la chaîne et diviser par les délimiteurs
    const parts = value.trim().split(/[\s,;]+/);

    // Vérifier que chaque partie non vide est un nombre valide
    return parts
      .filter((part) => part !== '')
      .every((part) => /^[+-]?\d+(\.\d+)?$/.test(part));
  }


  static getTextSeparator(): RegExp {
    return /[,;\n\r]/; // En mode texte, NE PAS inclure l'espace comme séparateur
  }

  static getNumericSeparator(): RegExp {
    return /[\s,;]+/; // En mode numérique, inclure espace, virgule, point-virgule et retour à la ligne
  }

  static getSeparatorForValue(value: string): RegExp {
    return Util.isNumericWithDelimiters(value) ? this.getNumericSeparator() : this.getTextSeparator();
  }

  static pasteEvent(form: any, filter: any): void {
    let value = form.get(filter.name).value.toString().trim();

    if (Util.isNumericWithDelimiters(value)) {
      // Remplacement des séparateurs uniquement entre nombres
      let value2 = value.replaceAll(/(\d)\s+(\d)/g, '$1,$2'); // Remplace uniquement les espaces entre chiffres par une virgule
      let value3 = value2.replaceAll(/[;\n\r]+/g, ','); // Remplace ; \n \r par des ,
      let valueArray = value3.split(','); // Séparer en tableau de valeurs
      form.get(filter.name).patchValue(valueArray);
    } else {
      // Si c'est du texte, on ne remplace PAS les espaces
      const currentValue = form.get(filter.name).value ?? [];
      form.get(filter.name).setValue(currentValue);
    }
  }

  // Ajoute la valeur courante comme token si la touche pressée est un séparateur (numérique/texte).
  static addTokenOnSeparatorKey(event: KeyboardEvent, control: AbstractControl): boolean {
    const input = event.target as HTMLInputElement;
    const text = input.value ?? '';
    const separator = Util.getSeparatorForValue(text || event.key);
    if (event.key.length === 1 && separator.test(event.key)) {
      const value = text.trim();
      if (value) {
        const current: string[] = control.value ?? [];
        if (!current.includes(value)) {
          control.setValue([...current, value]);
        }
        input.value = '';
      }
      event.preventDefault();
      return true;
    }
    return false;
  }

  // Découpe le texte collé en tokens selon la détection numérique/texte.
  static pasteTokens(event: ClipboardEvent, control: AbstractControl): boolean {
    const text = event.clipboardData?.getData('text') ?? '';
    if (!text.trim()) {
      return false;
    }
    event.preventDefault();
    const separator = Util.getSeparatorForValue(text);
    const current: string[] = control.value ?? [];
    const additions = text
      .split(separator)
      .map((value) => value.trim())
      .filter((value) => value && !current.includes(value));
    if (additions.length) {
      control.setValue([...current, ...additions]);
    }
    return true;
  }
  /**
   * Initialise les catégories à partir du service
   * @param categoryService - Le service de catégories
   * @param channelService - Le service de canaux
   * @returns Une fonction qui renvoie un observable de catégories
   */
  static initCategories(categoryService, channelService) {
    return () => {
      return new Promise((resolve) => {
        categoryService.getCategories().subscribe({
          next: (res) => {
            const categories = structuredClone(res);
            const localizedCategories = categoryService.getCaterogyByLocale(
              categories,
              channelService.getSelectedLocale(),
            );

            for (let node of localizedCategories) {
              Util.handleSlectableNodes(node);
            }

            resolve(localizedCategories);
          },
        });
      });
    };
  }

  /**
   * Définit si un nœud est sélectionnable selon s'il a des enfants
   * @param node - Le nœud à traiter
   */
  static handleSlectableNodes(node) {
    if (node.hasChildren == 'true') {
      node.selectable = false;
      for (let child of node.children) {
        Util.handleSlectableNodes(child);
      }
    }
  }

  static handleExportSuccess(response: any): void {
    if (!response.body || response.body?.size === 0) {
      console.error('Le corps de la réponse est vide');
      return;
    }

    const filename = Util.getFilenameFromHeaders(response.headers);
    const blob = new Blob([response.body], {
      type: 'application/octet-stream',
    });
    const url = globalThis.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    globalThis.URL.revokeObjectURL(url);
  }

  static handleExportError(err: any): void {
    console.error('Download failed', err);
  }

  static openFilterModal(
    dialogService: DialogService,
    translate: TranslateService,
    componentRef: any,
    initFilters: Function,
    onAfterClose: Function
  ) {

    const boundInitFilters = initFilters.bind(componentRef);
    boundInitFilters();

    const ref = dialogService.open(FilterProductComponent, {
      header: translate.instant('global.filter'),
      dismissableMask: true,
      focusOnShow: false,
      closable: true,
      data: { filters: componentRef.filters, appliedFilters: componentRef.appliedFilters },
      width: '80vw',
      height: '75vh',
      modal: true,
      breakpoints: {
        '960px': '75vw',
        '640px': '90vw',
      },
    });

    ref.onClose.subscribe((data) => {
      if (!data) return;




      this.handleFilters(componentRef, data);
      const boundOnAfterClose = onAfterClose.bind(componentRef);
      boundOnAfterClose({
        first: 0,
        rows: componentRef.rows ?? 100,
        sortField: null,
        sortOrder: null,
      });
    });

    return ref;
  }

  static resetFilters(componentRef: any, onAfterReset: Function) {
    componentRef.tags = [];
    componentRef.searchFilters = {};
    componentRef.appliedFilters = {};


    const boundOnAfterReset = onAfterReset.bind(componentRef);
    boundOnAfterReset({
      first: 0,
      rows: componentRef.rows ?? 100,
      sortField: null,
      sortOrder: null,
    });
  }

  static handleFilters(componentRef: any, data: any) {
    if (!data) return;

    componentRef.tags = [];
    componentRef.searchFilters = {};

    for (let key in componentRef.appliedFilters) {
      if (!data[key]) {
        componentRef.appliedFilters[key] = []
        delete componentRef.appliedFilters[key];
      }
    }

    for (let key in data) {
      if (data[key]) {
        componentRef.appliedFilters[key] = data[key]; // Ajoute le filtre

        let tags, filters;
        [tags, filters] = FiltersUtil.handleFilters(data, key);

        if (key === 'status') {
          componentRef.searchFilters = { ...componentRef.searchFilters, ...filters };
        } else {
          componentRef.searchFilters[key] = filters;
        }

        tags = tags.filter(tag => tag.valueString != '' && tag.value.length > 0);

        if (tags.length > 0) {
          componentRef.tags = componentRef.tags.concat(tags);
        }
      }
    }


    componentRef.appliedFilters = { ...componentRef.appliedFilters };
    componentRef.tags = [...componentRef.tags];
  }
  static getCorrectFilterName(value: string, filterMap: { [key: string]: string }): string {
    return filterMap[value] || value;
  }


  static removeFilter(val: string, parent: string | null, componentRef: any , onLazyLoad: Function, rows: number, filterMap: { [key: string]: string }): void {
    componentRef.tags = componentRef.tags.filter((tag) => tag.name !== val);
    const value = Util.getCorrectFilterName(val, filterMap);
     componentRef.searchFilters[value] = [];
     delete componentRef.searchFilters[value];

    if (parent) {
      componentRef.appliedFilters[parent] = componentRef.appliedFilters[parent].filter(
        (filter) => filter.group !== value,
      );
      if (componentRef.appliedFilters[parent].length === 0) {
         componentRef.appliedFilters[parent] = [];
         delete componentRef.appliedFilters[parent];
      }
    } else {
       componentRef.appliedFilters[value] = [];
       delete componentRef.appliedFilters[value];
    }
    componentRef.appliedFilters = { ...componentRef.appliedFilters };
    const boundOnLazyLoad = onLazyLoad.bind(componentRef);
    boundOnLazyLoad({
      first: 0,
      rows: rows,
      sortField: null,
      sortOrder: null,
    });
  }

  static buildMessage(prefix, obj, fields) {
    const parts = [];

    for (const field of fields) {
      const value = obj[field];
      if (value !== undefined && value !== null && value !== '') {
        parts.push(value);
      }
    }

    // Ajoute le préfixe sans ":" après, puis join les autres avec " : "
    return parts.length ? prefix + ' ' + parts.join(' : ') : prefix;
  }

  static getDetailArray(detail: any): string[] {
    return Array.isArray(detail) ? detail : [];
  }

  static isArray(obj) {
    return Array.isArray(obj)
  }

  static downloadDoc(url: string) {
    const link = document.createElement('a');
    link.href = url;
    link.download = '';
    link.target = '_blank';
    link.rel = 'noopener noreferrer'; // Pour la sécurité
    link.click();
  }

   static showSuccessMessage(messageService: MessageService, translateService: TranslateService): void {
    messageService.add({
      severity: 'success',
      summary: translateService.instant('alerts.successSummary'),
      detail: translateService.instant('alerts.success'),
    });
  }

  static showErrorMessage(messageService: MessageService, translateService: TranslateService): void {
    messageService.add({
      severity: 'error',
      summary: translateService.instant('alerts.error'),
      detail: translateService.instant('alerts.errorSummary'),
    });
  }
}
